module.exports = __webpack_public_path__ + "prod/1.42.2/img/new-mode-five.07710c86.png";